<template>
	<g clip-path="url(#icon-low-latency-mode-clip0)">
		<path
			d="M6.13581 3.39306C6.98695 2.92982 7.96271 2.66663 8.99994 2.66663C12.3136 2.66663 14.9999 5.35292 14.9999 8.66663C14.9999 11.9803 12.3136 14.6666 8.99994 14.6666C6.44783 14.6666 4.26787 13.0732 3.40063 10.827"
			stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M9 8.66667V6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
			stroke-linejoin="round" />
		<path d="M7.6665 1.33337H10.3332" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
		<path d="M7 5H3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M6 7L1 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M5 9H1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
	</g>
	<defs>
		<clipPath id="icon-low-latency-mode-clip0">
			<rect width="16" height="16" fill="white" />
		</clipPath>
	</defs>
</template>
